export default __webpack_public_path__ + "static/media/jp.7a8f47e8.jpg";